import camelCase from 'lodash/camelCase';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { servicedeskPlaybooksTemplatesRoute } from '@atlassian/jira-router-routes-project-settings-playbooks-routes/src/servicedeskPlaybooksTemplatesRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { SIDEBAR_ID, MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import playbookTemplatesEntryPoint from '@atlassian/jira-spa-apps-project-settings-playbooks-templates-view/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { playbooksListRequestTypesResource } from '@atlassian/jira-playbooks-list-screen-router-resources/src/services/index.tsx';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { isFedRamp } from '@atlassian/atl-context';
import playbooksHorizontalNavEntrypoint from '@atlassian/jira-spa-apps-project-settings-playbooks-horizontal-nav/entrypoint.tsx';
import { PlaybookTemplatesLoadingView } from '@atlassian/jira-playbooks-list-screen/src/ui/playbook-templates/edge-cases/PlaybookTemplatesLoadingView.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const templatesEntryPoint = createPageEntryPoint({
	main: playbookTemplatesEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: playbooksHorizontalNavEntrypoint,
});

export const servicedeskPlaybooksTemplatesRouteEntry = createEntry(
	servicedeskPlaybooksTemplatesRoute,
	() => ({
		group: 'project-settings-servicedesk',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},
		entryPoint() {
			if (isFedRamp() || !fg('phantom-3577-playbook-templates')) {
				return notFoundPageEntrypoint;
			}
			return templatesEntryPoint;
		},
		resources: [
			...getServiceDeskSettingsResources(),
			getConsolidationStateResource(),
			playbooksListRequestTypesResource,
		],
		meta: {
			reporting: {
				id: 'project-settings.playbooks.templates-view',
				packageName: camelCase('project-settings-playbooks-templates'),
				teamName: 'ITOps Phantom',
			},
		},
		component: ErrorPagesNotFound,
		ufoName: 'playbook-templates',
		skeleton: PlaybookTemplatesLoadingView,
		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-project-settings-playbooks-entries/src/servicedeskPlaybooksTemplatesRouteEntry.tsx',
				whichExportToUse: 'servicedeskPlaybooksTemplatesRouteEntry',
			},

			enabled: true,
		},
	}),
);
